import ResponseCodes from '../constants/response-codes.constant';
import { ResponseTO } from '../types/response-to.type';

const Mapper: { [key: number]: string } = {
    [ResponseCodes.INVALID_CARD_PAYMENT]:
        'Datos de tarjeta inválidos. Por favor revísalos e inténtalo nuevamente.',
    [ResponseCodes.CARD_INSUFFICIENT_FUNDS]:
        'La tarjeta no tiene fondus suficientes para esta compra.',
    [ResponseCodes.FRAUDULENT_CARD]:
        'Esta tarjeta no está permita. Por favor usa otra.',
    [ResponseCodes.INVALID_PAYMENT]:
        'Tarjeta inválida. Por favor inténtalo de nuevo o usa otra.',
};

// BVC direct-debit rejection strings (descResp field from payments-api)
const BvcDescRespMapper: Record<string, string> = {
    insufficient_funds:
        'Fondos insuficientes para completar el pago. Verifica tu saldo e intenta de nuevo.',
    invalid_token:
        'El código OTP ingresado es inválido. Inicia el proceso nuevamente.',
    reference_not_found:
        'No se encontró la referencia de pago. Inicia el proceso nuevamente.',
};

export const mapResponseError = (response: ResponseTO) => {
    const descResp = (response as any).descResp as string | undefined;
    if (descResp) return BvcDescRespMapper[descResp] ?? descResp;
    if (Mapper[response.code]) return Mapper[response.code];
    return response.message ?? 'Ocurrió un error inesperado. Intenta de nuevo.';
};
